<template>
    <div class="purchase">
        <div class="pur">
            <h5>购买信息</h5>
            <span>
                <el-button type="primary" @click="editAddDomain" size="mini">添加购买项目</el-button>
            </span>
        </div>
        <div class="card" ref="purData">
            <div v-for="(domain, index) in purData" :key="index">
                <el-form-item label="项目名称" :prop="'purchaseInformationList.' + index + '.projectId'" :rules="rules.projectId">
                    <el-select :disabled="status == ''||domain.isCreate==true?true:false" @input="testSX" ref="project" @keydown.enter.native="enterDoctor($event, 5, index)" default-first-option @focus="musFocus" @change="musChange($event, index)" clearable v-model="domain.projectId" filterable placeholder="请选择购买项目" :filter-method="projectMatch">
                        <el-option v-for="item in newData" :key="item.id" :label="item.project" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="项目补充">
                    <el-input :disabled="domain.isCreate==true?true:false" @input="testSX" v-model="domain.projectReplenish" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="疗程购买次/支" :prop="'purchaseInformationList.' + index + '.purchaseNumber'" label-width="110px" :rules="rules.purchaseNumber">
                    <el-input :disabled="domain.isCreate==true?true:false" @input="testSX" v-model="domain.purchaseNumber" placeholder="请输入" oninput="value=value.replace(/[^0-9.]/g, '')"></el-input>
                </el-form-item>
                <el-form-item label="疗程收费" :prop="'purchaseInformationList.' + index + '.projectAmt'" :rules="rules.projectAmt">
                    <el-input :disabled="domain.isUpdate==true?true:false" @input="testSX" v-model="domain.projectAmt" placeholder="请输入费用" oninput="value=value.replace(/[^0-9.]/g, '')"></el-input>
                </el-form-item>
                <el-form-item label="购买日期" :prop="'purchaseInformationList.' + index + '.createTime'" :rules="rules.createTime">
                    <el-date-picker :disabled="domain.isCreate==true?true:false" @input="testSX" v-model="domain.createTime" type="date" placeholder="请选择购买日期" value-format="yyyy-MM-dd"></el-date-picker>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input :disabled="domain.isUpdate==true?true:false" @input="testSX" v-model="domain.purchaseRemark" placeholder="请输入备注"></el-input>
                </el-form-item>
                <el-button size="mini" type="danger" :disabled="domain.residueNumber==null||parseInt(domain.residueNumber) == parseInt(domain.purchaseNumber)?false:true" @click.prevent="editRemoveDomain(domain, index)">删除</el-button>
                <el-button size="mini" type="warning" @click="editPrice(domain, index)">修改价格</el-button>
            </div>
            <div class="flex">
                <el-button style="width:200px;" type="primary" size="mini" @click.prevent="addSure('purData')">确定</el-button>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import { v4 as uuidv4 } from "uuid";
import { log } from 'util';
export default {
    props: ['purData', 'status', 'projectData', 'formData'],
    data() {
        return {
            newData: [],
            uuid: '',
            rules: {
                projectId: [{ required: true, message: "请添加项目名称", trigger: "blur" }],
                purchaseNumber: [{ required: true, message: "请添加购买数量", trigger: "blur" }],
                projectAmt: [{ required: true, message: "请输入费用", trigger: "blur" }],
                createTime: [{ required: true, message: "请选择日期", trigger: "blur" }],
            },
        }
    },
    computed: {
        ...mapState(["nameOptions",]),
        ...mapGetters(["productOptions",]),
    },
    mounted() {
    },
    created() {
        this.newData = this.$store.getters.productOptions;
        this.allData = this.$store.getters.productOptions;
    },
    methods: {
        // 编辑时新增部位
        editAddDomain(index) {
            this.purData.push({
                key: Date.now(),
                project: "",
                projectId: "",
                purchaseNumber: "",
                projectReplenish: "",
                projectAmt: "",
                purchaseRemark: '',
                projectType: "1",
                createTime: "",
                purchaseId: uuidv4(),
                isCreate: false,
                isUpdate: false,
            });
        },
        // 编辑时删除部位
        editRemoveDomain(item, listIndex) {
            // console.log(item);
            var index = this.purData.indexOf(item);
            let num = parseInt(item.refundResidueNumber) + parseInt(item.residueNumber)
            if (index != -1) {
                if (item.projectReplenish == '' || item.purchaseNumber == '' || item.projectAmt == '' || item.residueNumber == null || item.refundResidueNumber == null || parseInt(item.residueNumber) == num) {
                    busPhone.$emit('tableId', item.purchaseId) // 传值
                    this.purData.splice(listIndex, 1);
                }
            }
            this.sing()
        },
        enterDoctor(e, val, index) {
            if (val == 5) {
                //项目名称
                if (this.newData[0] != undefined) {
                    this.purData[index].projectId = this.newData[0].id;
                    this.purData[index].project = this.newData[0].project;
                    this.$forceUpdate();
                    this.$refs.project[0].blur();
                }
            }
        },
        musFocus(val, index) {
            if (this.status == "") {
                this.newData = [];
                _g.toast("warning", "请先获取客户消费数据!");
                return;
            }
            this.newData = this.$store.getters.productOptions;
        },
        projectMatch(val) {
            this.newData = _g.paramMatch(this.productOptions, this.newData, val, 'project')
        },
        testSX() {
            this.$forceUpdate();
        },
        sing() {
            this.newData = this.$store.getters.productOptions;
        },
        musChange(val, index) {
            this.purData.purchaseNumber = 1;
        },
        /*** 查询当天日期*/
        getNowDate() {
            const timeOne = new Date()
            const year = timeOne.getFullYear()
            let month = timeOne.getMonth() + 1
            let day = timeOne.getDate()
            month = month < 10 ? '0' + month : month
            day = day < 10 ? '0' + day : day
            const NOW_MONTHS_AGO = `${year}-${month}-${day}`
            return NOW_MONTHS_AGO
        },
        addSure(purData) {
            console.log(this.purData);
            let flag1 = this.purData.every(item => !!item.projectId)
            let flag2 = this.purData.every(item => !!item.projectAmt)
            let flag3 = this.purData.every(item => !!item.createTime)
            let flag4 = this.purData.every(item => !!item.purchaseNumber)
            // console.log(flag1);
            if (!flag1) {
                _g.toast("warning", "请填写项目名称!");
                return
            } else if (!flag2) {
                _g.toast("warning", "请填写项目金额!");
                return
            } else if (!flag3) {
                _g.toast("warning", "请填写日期!");
                return
            } else if (!flag4) {
                _g.toast("warning", "请填写次数!");
                return
            } else {
                this.purData.forEach(item => {
                    if (item.residueNumber == null || parseInt(item.residueNumber) == parseInt(item.purchaseNumber)) {
                        item.residueNumber = item.purchaseNumber
                    }
                    this.allData.forEach(ele => {
                        if (ele.id == item.projectId) {
                            item.projectId = ele.id
                            item.projectName = ele.project
                            item.isCreate = true
                            item.isUpdate = true
                            item.remark = item.purchaseRemark
                        }
                    });
                });
                busPhone.$emit('list', this.purData) // 传值
                this.purData.forEach(ele => {
                    this.formData.musInformationList.forEach(item => {
                        if (item.purchaseId == ele.purchaseId) {
                            item.unitPrice = parseFloat(ele.projectAmt) / parseFloat(ele.purchaseNumber)//项目单价
                        }
                    });
                });
                busPhone.$emit('busList', this.formData.musInformationList)
                this.$forceUpdate()
            }
        },
        editPrice(domin, index) {
            console.log(domin);
            domin.isUpdate = false
            this.$forceUpdate()
        },
    }
}
</script>
<style scoped>
.typeClass >>> .el-select .el-input__inner {
  width: 80px !important;
}
.pur {
  display: flex;
  align-items: center;
}
.flex {
  display: flex;
  justify-content: center;
}
.pur h5 {
  margin-right: 10px;
}
.card {
  background: #e0e6f0;
  border-radius: 10px;
  margin-bottom: 2px;
  padding-top: 5px;
  box-sizing: border-box;
}
.card >>> .el-button i {
  margin: 0 !important;
}
.card >>> .el-button--mini {
  margin-top: 5px;
}

.card >>> .el-select .el-input__inner {
  width: 180px;
  height: 30px;
  line-height: 30px;
  font-size: 12px;
}
.card >>> .el-input__inner {
  width: 180px;
  height: 30px;
  line-height: 30px;
  font-size: 12px;
}
.card >>> .el-form-item__label {
  line-height: 30px;
}
.card >>> .el-input__icon {
  line-height: 30px;
}
.card >>> .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 180px;
  height: 30px;
  line-height: 30px;
}
</style>


